import { complianceApi } from '@atheneum/api'
import { extendObservable } from 'mobx'

class ComplianceStore {
  constructor () {
    extendObservable(this, {
      complianceLanguages: [],
      loading: false,
      error: null
    })

    this.getComplianceLanguages()
  }

  getComplianceLanguages = () => {
    this.loading = true
    return complianceApi.getAll()
      .then(res => {
        this.complianceLanguages = res
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.error = err
      })
  }

  create = complianceApi.create

  update = complianceApi.update
}

export default ComplianceStore
